import React from 'react';

import Threshold360 from 'components/Threshold360';
import { useThreshold360Query } from 'hooks/useThreshold360Query';

const Threshold360Provider = ({ id }) => {
    const { data } = useThreshold360Query({ id });
    return <Threshold360 {...data} />;
};

export default Threshold360Provider;